import React from 'react';
import { Box, Typography, Link } from '@mui/material';

function Footer() {
  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 4,
        color: '#ffffff',
        backgroundColor: '#000000', // Более темный фон для PlayStation-стиля
        boxShadow: '0px -2px 20px rgba(0, 0, 0, 0.3)', // Легкая тень для выделения футера
      }}
    >
      <Box
        sx={{
          borderTop: '1px solid #333333',
          pt: 3,
          color: '#999999', // Цвет для нижнего текста
        }}
      >
        <Typography variant="body2">
          Manas 5, Kyrgyzstan, Bishkek | Game Zone Club
        </Typography>
        <Typography variant="body2" sx={{ marginTop: '1.5rem' }}>
          &copy; 2025 Все права защищены
        </Typography>
        <Typography variant="body2" sx={{ marginTop: '1.5rem' }}>
          <Link
            href="https://www.instagram.com/matraim.official/"
            color="inherit"
            underline="hover"
            sx={{
              color: '#999999',

              '&:hover': { color: '#FF4081' }, // Плавный переход в розовый при наведении
            }}
            target="_blank"
          >
            Created by Matraim
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;
